export enum TherapyMotivationTestId {
    Continue = 'TherapyMotivationTestId.Continue',
    Previous = 'TherapyMotivationTestId.Previous',
}

export enum TherapySupportWithTestId {
    Continue = 'TherapySupportWithTestId.Continue',
    Previous = 'TherapySupportWithTestId.Previous',
}

export enum WorkWithProviderIntroTestId {
    Continue = 'WorkWithProviderIntroTestId.Continue',
}
